import { useEffect, useState } from "react";
import { Check, CloudOff, Loader2, AlertTriangle, Smartphone } from "lucide-react";
import { useDatos } from "../store/store";

const hace = (iso: string | null) => {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "hace un momento";
  if (s < 3600) return `hace ${Math.round(s / 60)} min`;
  return new Date(iso).toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" });
};

export function IndicadorGuardado() {
  const m = useDatos((s) => s.meta);
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 30_000); return () => clearInterval(t); }, []);
  if (m.modo === "demo") return <span className="text-xs text-tinta-suave">Ejemplo · no se guarda</span>;
  const base = "inline-flex items-center gap-1 text-xs";
  switch (m.guardado) {
    case "guardando": return <span className={`${base} text-tinta-suave`} role="status"><Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden />Guardando…</span>;
    case "pendiente": return <span className={`${base} text-tinta-suave`}>Cambios sin guardar…</span>;
    case "guardado": return <span className={`${base} text-emerald-800`}><Check className="h-3.5 w-3.5" aria-hidden />Guardado {hace(m.lastSavedAt)}</span>;
    case "offline": return <span className={`${base} text-amber-800`}><CloudOff className="h-3.5 w-3.5" aria-hidden />Sin conexión: guardado en este dispositivo</span>;
    case "local": return <span className={`${base} text-amber-800`} title={m.error ?? undefined}><Smartphone className="h-3.5 w-3.5" aria-hidden />Guardado en este dispositivo</span>;
    case "error": return <span className={`${base} text-red-800`} title={m.error ?? undefined}><AlertTriangle className="h-3.5 w-3.5" aria-hidden />No pude guardar</span>;
    default: return null;
  }
}
